import { GET_LIST_NOTIF } from '@/dataSource/api/Notif/apiNiotif'
import { defineStore } from 'pinia'
import { ShowPerPage } from '../showPerPage/showPerPage'
import { getIndexedDB, setIndexedDB } from '@/dataSource/indexed-DB/indexedDB'
import router from '@/router'


interface TypeList {
    result: any
    dataList: any
    loading: Boolean
    emptyList: boolean
}
interface PageInt {
    numPage: number
    statusNextPage: Boolean
}
interface errMessage {
    errMessage: string
    showCardMessage: Boolean
}
interface successMessage {
    successMessage: string
    showCardMessage: Boolean
}
interface result {
    data: TypeList
    PageInt: PageInt
    err: errMessage
    success: successMessage
}
export const ListNotif = defineStore('ListNotif', {
    state: () => <result>({
        data: {
            result: [],
            dataList: [],
            loading: false,
            emptyList: false
        },

        PageInt: {
            numPage: 1,
            statusNextPage: false
        },
        err: {
            errMessage: '',
            showCardMessage: false
        },
        success: {
            successMessage: '',
            showCardMessage: false
        }
    }),
    actions: {
        async handelPageInt() {
            if (!this.PageInt.statusNextPage && this.data.result.data.announcement.length == ShowPerPage) {
                if (window.innerHeight + window.pageYOffset + 200 >= document.body.offsetHeight) {
                    this.PageInt.numPage++
                    this.PageInt.statusNextPage = true
                    this.handelData(this.PageInt.numPage)
                }
            }
        },
        async handelData(page?: any) {

            if (page) {
                this.data.result = await GET_LIST_NOTIF(page)
            }
            else {
                this.data.loading = true
                this.data.result = await GET_LIST_NOTIF()
            }
            await setIndexedDB('list-notif', JSON.stringify(this.data.dataList))
            this.handelList()
            this.checkEmptyList()
        },
        async handelList() {
            this.data.loading = false
            if (this.PageInt.statusNextPage && this.PageInt.numPage > 1) {
                this.data.dataList = this.data.dataList.concat(this.data.result.data.announcement)
            } else {
                this.data.dataList = this.data.result.data.announcement
            }
            this.PageInt.statusNextPage = false
        },
        async checkStatusUser() {
            if (window.navigator.onLine) {
                this.handelData()
            } else {
                this.data.loading = true
                this.handelOfflineList()
            }
        },
        async handelOfflineList() {
            this.data.loading = false
            this.data.dataList = await getIndexedDB('list-notif')
            this.data.dataList = JSON.parse(this.data.dataList)
            this.checkEmptyList()
        },
        async handelClickEventPage(nameRoute: string, NotifID?: number) {
            if (window.navigator.onLine) {
                if (NotifID) {
                    router.push({ name: nameRoute, params: { id: NotifID } })
                } else {
                    router.push({ name: nameRoute })
                }
            } else {
                this.err.showCardMessage = true
                this.err.errMessage = 'شما آفلاین هستید .'
                setTimeout(() => {
                    this.err.showCardMessage = false
                    this.err.errMessage = ''
                }, 2000)
            }
        },

        async checkEmptyList() {
            if (this.data.dataList.length == 0) {
                this.data.emptyList = true
            } else {
                this.data.emptyList = false
            }
        }

    }
})